import HeadTitle from './HeadTitle';
export { HeadTitle };
export default HeadTitle;
